<div class="c-form-field c-form-field--code" [ngClass]="cssClass">
  <input type="text" [placeholder]="placeholder" required="required" name="text" [formControl]="control" />
  <div class="c-form-field__label">{{ label }}</div>
  <div class="c-form-field__msg -error" *ngIf="errorText">{{ errorText }}</div>
  <div class="c-form-field__resend c-link" [hidden]="isLoading" (click)="resendCode()">Resend</div>
</div>
